var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-white-background"},[_c('div',{staticClass:"top-spacing container column"},[_c('TablePriceFacility',{attrs:{"is-vietinbank":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }